import React from 'react'
import { PieChart, Pie, Cell } from 'recharts'
import styles from './insights.module.scss'

const PIE_SIZES = {
  full: {
    width: 720,
    height: 400,
    outerRadius: 115,
    margin: { top: 24, right: 140, bottom: 24, left: 140 },
    labelOffset: 28,
    fontSize: 12,
    truncateAt: 28,
    twoLineAt: 20
  },
  compare: {
    width: 360,
    height: 360,
    outerRadius: 88,
    margin: { top: 16, right: 72, bottom: 16, left: 72 },
    labelOffset: 22,
    fontSize: 10,
    truncateAt: 22,
    twoLineAt: 16
  }
}

const PIE_COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#dff334']
const RADIAN = Math.PI / 180

const InsightsPieChart = ({ data, size = 'full' }) => {
  if (!data || data.length === 0) return null

  const config = PIE_SIZES[size] || PIE_SIZES.full

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    outerRadius,
    percent,
    index
  }) => {
    const labelRadius = outerRadius + config.labelOffset
    const x = cx + labelRadius * Math.cos(-midAngle * RADIAN)
    const y = cy + labelRadius * Math.sin(-midAngle * RADIAN)
    const name = data[index].name
    const displayName =
      name.length > config.truncateAt
        ? name.slice(0, config.truncateAt - 2) + '…'
        : name
    const pct = (percent * 100).toFixed(0) + '%'
    const twoLines = displayName.length > config.twoLineAt

    return (
      <text
        x={x}
        y={y}
        fill="#333"
        fontSize={config.fontSize}
        textAnchor={x > cx ? 'start' : 'end'}
        dominantBaseline="central">
        {twoLines ? (
          <>
            <tspan x={x} dy={-6}>
              {displayName}
            </tspan>
            <tspan x={x} dy={12}>
              {pct}
            </tspan>
          </>
        ) : (
          <tspan x={x}>
            {displayName + ' ' + pct}
          </tspan>
        )}
      </text>
    )
  }

  return (
    <div
      className={`${styles.chartWrap} ${styles.pieChartWrap} ${
        size === 'compare' ? styles.pieChartCompare : ''
      }`}>
      <PieChart
        width={config.width}
        height={config.height}
        margin={config.margin}>
        <Pie
          data={data}
          isAnimationActive={false}
          cx="50%"
          cy="50%"
          labelLine={{ stroke: '#666', strokeWidth: 1 }}
          label={renderCustomizedLabel}
          outerRadius={config.outerRadius}
          fill="#8884d8"
          dataKey="value">
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={PIE_COLORS[index % PIE_COLORS.length]}
            />
          ))}
        </Pie>
      </PieChart>
    </div>
  )
}

export default InsightsPieChart
